import React, { useEffect, useState } from 'react'
import InstallationAddDeviceView from './InstallationAddDeviceView'
import crmservices from '../../wsclient';
import { useTranslation } from 'react-i18next';
import LoadingComponent from '../../components/Loading';
import AlertComponent from '../../components/Alert';
import { Dialog, DialogContent, Grid } from '@mui/material';
import LinearBuffer from './LinearBuffer';
import { sleep } from '../../utils/util';
import { httpBackOfficeUtil } from '../../wsclient/crmservices/httpBackOfficeUtil';
export default function InstallationAddDeviceController(props) {
    const organisation_id = document._portalConfig.organisation_id;
    const { t } = useTranslation();
    const [activeStep, setActiveStep] = useState(props.activeStepAddDevice ? props.activeStepAddDevice : 0);
    const [message, setMessage] = useState();
    const [stepMessage, setStepMessage] = useState();
    const [showProcessing, setShowProcessing] = useState(false);
    const [showLoadingSubscription, setShowLoadingSubscription] = useState(true);
    const [showLoadingService, setShowLoadingService] = useState(false);
    const [showLoadingDevice, setShowLoadingDevice] = useState(true);
    const [showLoadingServiceDevice, setShowLoadingServiceDevice] = useState(false);
    const [subscriptions, setSubscriptions] = useState([]);
    const [devices, setDevices] = useState([]);
    const [services, setServices] = useState([]);
    const [serviceDevices, setServiceDevices] = useState([]);
    const [subscriptionSelected, setSubscriptionSelected] = useState();
    const [deviceSelected, setDeviceSelected] = useState([]);
    const [quantityService, setQuantityService] = useState(false);
    const [serviceSelected, setServiceSelected] = useState([]);
    const [serviceToReloadDevice, setServiceToReloadDevice] = useState(null);
    const [loadingState, setLoadingState] = useState(false);
    const [actionState, setActionState] = useState(false);

    const { orderDetail, activity } = props;
    const customerContact = orderDetail ? orderDetail.contact : null;

    useEffect(() => {
        if (customerContact) {
            onLoadSubscription();
            getTotalProduct();
        }
    }, [customerContact])

    useEffect(() => {
        console.log("AAAAA subscriptionSelected:", subscriptionSelected);
        if (subscriptionSelected) {
            if (activeStep == 0) {
                onLoadAllowDevices();
            } else {
                onLoadServices();
            }
        }
    }, [subscriptionSelected])

    useEffect(() => {
        if (activeStep == 1 && subscriptionSelected) {
            onLoadServices();
        }
    }, [activeStep])


    const getTotalProduct = () => {
        let items = orderDetail.items ? orderDetail.items : [];
        const filterItems = items.filter(i => {
            return i.product.sku != "Installation Service"
        })
        let quantity = filterItems ? filterItems.length : 0;
        setQuantityService(quantity)
    }

    const onLoadSubscription = async () => {
        let _subscriptions = [];
        try {
            const result = await crmservices.subscriptions.getContactSubscriptions(customerContact.id);
            if (result.code == 'OK') {
                _subscriptions = result.data.content ? result.data.content : [];
            }
        } catch (ex) {
            console.log("AAAAAAAA onLoadSubscription:", ex);
        }
        console.log('onLoadSubscription _subscriptions:', _subscriptions);
        if (_subscriptions.length > 0) {
            setSubscriptionSelected(_subscriptions[0]);
        }
        setSubscriptions(_subscriptions)
        setShowLoadingSubscription(false);
    }

    const onLoadAllowDevices = async () => {
        let devices = [];
        try {
            let myUserId = httpBackOfficeUtil.getSession().sub;
            const result = await crmservices.subscriptions.getDevice({ 
                owner_id: organisation_id,
                include_custom_fields: true,
                custom_fields: `contractor;${myUserId}`,
                include_subscription: false
             });
            if (result.code == 'OK') {
                devices = result.data.content ? result.data.content : [];
            }
        } catch (ex) {
            console.log("AAAAAAAA onLoadAllowDevices:", ex);
        }
        setDevices(devices)
        setShowLoadingDevice(false);
    }

    const onLoadServices = async () => {
        setShowLoadingService(true);
        let services = [];
        try {
            console.log('subscriptionSelected:', subscriptionSelected);
            console.log('customerContact:', customerContact);
            const result = await crmservices.subscriptions.getContactServices({ subscription_id: subscriptionSelected.id, contact_id: customerContact.id });
            if (result.code == 'OK') {
                services = result.data.content ? result.data.content : [];
            }
        } catch (ex) {
            console.log("AAAAAAAA onLoadServices:", ex);
        }
        let servicesWithDevices = [];
        if (services.length > 0) {
            for (let i = 0; i < services.length; i++) {
                let service = { ...services[i] };
                const devices = await onLoadDeviceForService(service.id);
                service.devices = devices;
                servicesWithDevices.push(service);
            }
        }
        setServices(servicesWithDevices)
        setShowLoadingService(false);
    }

    const onLoadDeviceForService = async (serviceID) => {
        let devices = [];
        try {
            const result = await crmservices.subscriptions.getServiceDevices({ service_id: serviceID });
            console.log("onLoadDeviceForService result:", result);
            if (result.code == 'OK') {
                devices = result.data.content ? result.data.content : [];
            }
        } catch (ex) {
            console.log("AAAAAAAA onLoadServices:", ex);
        }
        return devices;
    }


    const onSelectSubscription = (sub) => {
        setSubscriptionSelected(sub);
    }

    const onSelectServiceRow = (service) => {
        let existing = serviceSelected.filter(s => {
            return s.service_id == service.id
        });
        if (existing && existing.length > 0) {
            let _serviceSelected = serviceSelected.map(s => {
                if (s.service_id == service.id) {
                    s.is_active = true;
                } else {
                    s.is_active = false;
                }
                return s;
            });
            setServiceSelected(_serviceSelected);
        } else {
            let _serviceSelected = serviceSelected.map(s => {
                return { ...s, is_active: false }
            })
            let _newSelected = {
                service_name: service.product.name,
                service_id: service.id,
                device_id: null,
                device_serial_number: null,
                devices: [],
                is_active: true,
                is_checked: false
            }
            _serviceSelected.push(_newSelected);
            console.log("_serviceSelected:", _serviceSelected);
            setServiceSelected(_serviceSelected);
            if (service.id != serviceToReloadDevice) {
                setServiceDevices([]);
                setServiceToReloadDevice(service.id);
            }
        }
    }
    const onSelectService = (service) => {
        let _newSelected = {};
        let existing = serviceSelected.filter(s => {
            return s.service_id == service.id
        });
        console.log('xxxxxx existing:', existing);
        if (existing && existing.length > 0) {
            let _serviceSelectedFilter = serviceSelected.filter(s => {
                return s.service_id != service.id
            })
            let _serviceSelected = _serviceSelectedFilter.map(s => {
                return { ...s, is_active: false }
            });
            setServiceDevices([]);
            setServiceSelected(_serviceSelected);
        } else {
            let _serviceSelected = serviceSelected.map(s => {
                return { ...s, is_active: false }
            })
            _newSelected = {
                service_name: service.product.name,
                service_id: service.id,
                device_id: null,
                device_serial_number: null,
                devices: [],
                is_active: true,
                is_checked: true
            }
            _serviceSelected.push(_newSelected);
            console.log("_serviceSelected:", _serviceSelected);
            setServiceSelected(_serviceSelected);
            if (service.id != serviceToReloadDevice) {
                setServiceDevices([]);
                setServiceToReloadDevice(service.id);
            }
        }
    }


    const onSelectDeviceService = (service, device, isSelected) => {
        let _servicesSelected = [...serviceSelected];
        let existing = _servicesSelected.filter(s => {
            return s.service_id == service.id
        });
        console.log("existing:",existing);
        if (existing && existing.length > 0) {
            _servicesSelected = _servicesSelected.map(s => {
                if(s.service_id == service.id){
                    let devices = [...s.devices];
                    console.log("devices:",devices);
                    console.log("isSelected:",isSelected);
                    if (isSelected) {
                        devices = devices.filter(d => {
                            return d.device_id != device.id;
                        })
                    } else {
                        devices.push({
                            device_id: device.id,
                            device_serial_number: device.serial_number
                        })
                    }
                    s.devices = devices;
                }
                return s;
            })
            setServiceSelected(_servicesSelected);
        } else {
            let devices = [{
                device_id: device.id,
                device_serial_number: device.serial_number
            }]
            let newObj = {
                service_id: service.id,
                devices: devices,
                service_name: service.product.name,
            }
            let _serviceSelected = [...serviceSelected];
            _serviceSelected.push(newObj);
            setServiceSelected(_serviceSelected);
        }
    }

    // const onSelectDevice = (device, isSelected) => {
    //     if (deviceSelected.length >= quantityService && !isSelected) {
    //         return;
    //     } else {
    //         let _devices = [...deviceSelected];
    //         if (_devices.length == 0) {
    //             _devices.push(device);
    //         } else {
    //             let existing = _devices.filter(d => {
    //                 return d.id == device.id
    //             })
    //             if (existing && existing.length > 0) {
    //                 _devices = _devices.filter(d => {
    //                     return d.id != device.id
    //                 })
    //             } else {
    //                 _devices.push(device);
    //             }
    //         }
    //         setDeviceSelected(_devices);
    //     }
    // }

    const onSelectDevice = (undefined,device, isSelected) => {
        let _devices = [];
        _devices.push(device);
        setDeviceSelected(_devices);
    }

    const onSubmitStepAddDevice = async () => {
        setStepMessage(null);
        setActionState(null);
        setShowProcessing(true);
        try {
            let count = 0;
            let actionId = null;
            for (let i = 0; i < deviceSelected.length; i++) {
                const result = await crmservices.subscriptions.addSubscriptionDevices({
                    subscription_id: subscriptionSelected.id,
                    device_id: deviceSelected[i].id
                })
                if (result.code == 'OK') {
                    actionId = result.data.id;
                    count++;
                } else {
                    let message = t('ADD_DEVICE_FAILED') + "(Serial Number: " + deviceSelected[i].serial_number + ")"
                    if (result.code == 'CANNOTEXECUTEACTIONOVERDUEAMOUNTEXCEPTION') {
                        message = t('ADD_DEVICE_CANNOTEXECUTEACTIONOVERDUEAMOUNTEXCEPTION')
                    }
                    setStepMessage(message);
                    break;
                }
            }
            if (count == deviceSelected.length) {
                setShowProcessing(false);
                setLoadingState(true);
                const state = await checkSubscriptionExecuted(actionId)
                console.log("AAAA state:", state);
                if (state === "EXECUTED") {
                    await updateOrderCustomFields('adding_device');
                    setActiveStep(activeStep + 1);
                } else {
                    setStepMessage(t('ACTION_REJECTED'));
                }
                setLoadingState(false);
                setActionState(state);
            }
        } catch (ex) {
            showMessage({ status: true, message: t('EXCEPTION_PROCESS') });
        }
        setShowProcessing(false);
    }

    const updateOrderCustomFields = async (key, isUpdateAgainAddingDevice) => {
        try {
            let custom_fields = orderDetail.custom_fields;
            let filterCustomFields = custom_fields.filter(c => {
                return c.key != key
            })
            filterCustomFields.push({
                key: key,
                value: "1"
            })
            if (isUpdateAgainAddingDevice) {
                filterCustomFields = filterCustomFields.filter(c => {
                    return c.key != 'adding_device'
                });
                filterCustomFields.push({
                    key: 'adding_device',
                    value: "1"
                })
            }
            console.log("filterCustomFields ex:", filterCustomFields);
            await crmservices.orders.updateOrder({ custom_fields: filterCustomFields, order_id: orderDetail.id });
        } catch (ex) {
            console.log("AAAAAAA ex:", ex);
        }
    }

    const onSubmitStepEnableService = async () => {
        console.log("serviceSelected:", serviceSelected);

        let payload = createRequestToEnableService();
        if (payload.length == 0) {
            setStepMessage('Please select services and devices!');
            return;
        } else {
            setStepMessage(null);
            setActionState(null);
            setShowProcessing(true);
            try {
                let count = 0;
                for (let i = 0; i < payload.length; i++) {
                    const result = await crmservices.subscriptions.enableDevices(payload[i]);
                    console.log("onSubmitStepEnableService result", result);
                    if (result.code == 'OK') {
                        await sleep(3000);
                        let state = await getSubscriptionActionState(result.data.id);
                        if (state === "EXECUTED") {
                            count++;
                        } else {
                            let message = t('ACTION_REJECTED') + "  (" + payload[i].service_name + ")";
                            setStepMessage(message);
                            break;
                        }
                    } else {
                        let message = t('ENABLE_DEVICE_FAILED') + "(" + payload[i].service_name + ")";
                        setStepMessage(message);
                        break;
                    }
                }
                if (count == payload.length) {
                    await updateOrderCustomFields('enable_devices', true);
                    props.onClose(true);
                }
            } catch (ex) {
                showMessage({ status: true, message: t('EXCEPTION_PROCESS') });
            }
            setShowProcessing(false);
        }
    }

    const createRequestToEnableService = () => {
        let payload = [];
        serviceSelected.forEach(element => {
            if (element.devices && element.devices.length > 0) {
                payload.push(element);
            }
        });
        return payload;
    }

    const checkSubscriptionExecuted = async (actionId) => {
        let attempts = 3;
        let currentState = "PENDING_VERIFICATION";
        while (currentState == "PENDING_VERIFICATION" && attempts > 0) {
            currentState = await getSubscriptionActionState(actionId)
            if (attempts != 3) await sleep(3000); //delay 3s after first attempt
            attempts--;
        }
        return currentState
    }



    // get state to use in updateActivityIfExecuted function
    const getSubscriptionActionState = async (actionId) => {
        let state = null;
        try {
            const result = await crmservices.subscriptions.getSubscriptionAction({
                action_id: actionId
            });
            if (result.code === 'OK') {
                state = result.data.state;
                console.log("SubscriptionActionState: ", state);
            }
        } catch (error) {
            console.log("get updatingState error:", error);
            state = 'EXCEPTION'
        }
        return state
    }

    const showMessage = ({ status, title, message, otherMessage, callBackFn }) => {
        setShowProcessing(false);
        setMessage({ show: status, title: title, content: message, otherMessage, callBackFn: callBackFn ? callBackFn : () => setMessage({}) });
    }

    return (
        <>
            <InstallationAddDeviceView
                isOpen={props.isOpen}
                activeStep={activeStep}
                activity={activity}
                orderDetail={orderDetail}
                onClose={props.onClose}
                showLoadingSubscription={showLoadingSubscription}
                showLoadingDevice={showLoadingDevice}
                showLoadingService={showLoadingService}
                showLoadingServiceDevice={showLoadingServiceDevice}
                subscriptions={subscriptions}
                devices={devices}
                services={services}
                serviceDevices={serviceDevices}
                subscriptionSelected={subscriptionSelected}
                deviceSelected={deviceSelected}
                quantityPG={quantityService}
                message={message}
                stepMessage={stepMessage}
                serviceSelected={serviceSelected}
                loadingState={loadingState}
                actionState={actionState}
                onCancelAddDevice={props.onClose}
                onSelectSubscription={onSelectSubscription}
                onSelectDevice={onSelectDevice}
                onSelectService={onSelectService}
                onSelectDeviceService={onSelectDeviceService}
                onSubmitAddDevice={onSubmitStepAddDevice}
                onSubmitEnableService={onSubmitStepEnableService}
                onSelectServiceRow={onSelectServiceRow}
            />
            {showProcessing && <LoadingComponent showLoading={showProcessing} />}
            {message && message.show && <AlertComponent
                isOpen={message.show}
                message={message.content}
                otherMessage={message.otherMessage ? message.otherMessage : null}
                onClose={message.callBackFn}
            />}
            {loadingState &&
                <Dialog open={loadingState} sx={{ '& .MuiDialog-paper': { padding: '0px 0px' } }}>
                    <LinearBuffer status={actionState} />
                </Dialog>}
        </>
    )
}
